import React from "react";
import "./TermsAndConditions.css";
import {
  COUNTRY_NAME,
  MODAL_COUNTRY_MAP,
  TERMS_CONDITIONS_LABEL as label,
} from "../Common/constants";
import TermsConditions from "./TermsConditions";
import TermsAndConditionsIECContent from "./TermsAndConditionsIECContent";
import TermsAndConditionsNorwayContent from "./TermsAndConditionsNorwayContent";
import TermsAndConditionsSwedenContent from "./TermsAndConditionsSwedenContent";
import TermsAndConditionsOtherContent from "./TermsAndConditionsOtherContent";
import TermsAndConditionsUKContent from "./TermsAndConditionsUKContent";
import TermsAndConditionsJapanContent from "./TermsAndConditionsJapanContent";

const TermsAndConditionsWrapper = ({
  selectedCountries,
  agree,
  getChecked,
  lang,
}) => {
  const isIECSelected = selectedCountries?.includes(COUNTRY_NAME.INTERNATIONALEUROCARD);
  const isNorwaySelected = selectedCountries?.includes(COUNTRY_NAME.NORWAY);
  const isSwedenSelected = selectedCountries?.includes(COUNTRY_NAME.SWEDEN);
  const isJapanSelected = selectedCountries?.includes(COUNTRY_NAME.JAPAN);
  const isUKSelected = selectedCountries?.includes(COUNTRY_NAME.UNITEDKINGDOM);
  const isOtherCountriesSelected =
    selectedCountries?.includes(COUNTRY_NAME.OTHERCOUNTRIES);

  return (
    <>
      {isIECSelected && (
        <TermsConditions
          label={label.INTERNATIONALEUROCARD}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsIECContent
            selectedCountry={MODAL_COUNTRY_MAP.INTERNATIONALEUROCARD}
          />
        </TermsConditions>
      )}

      {isNorwaySelected && (
        <TermsConditions
          label={label.NORWAY}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsNorwayContent
            selectedCountry={MODAL_COUNTRY_MAP.NORWAY}
          />
        </TermsConditions>
      )}

      {isSwedenSelected && (
        <TermsConditions
          label={label.SWEDEN}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsSwedenContent
            selectedCountry={MODAL_COUNTRY_MAP.SWEDEN}
          />
        </TermsConditions>
      )}

      {isJapanSelected && (
        <TermsConditions
          label={label.JAPAN}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsJapanContent
            selectedCountry={MODAL_COUNTRY_MAP.JAPAN}
            lang={lang}
          />
        </TermsConditions>
      )}

      {isUKSelected && (
        <TermsConditions
          label={label.UNITEDKINGDOM}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsUKContent selectedCountry={MODAL_COUNTRY_MAP.UNITEDKINGDOM} />
        </TermsConditions>
      )}

      {isOtherCountriesSelected && (
        <TermsConditions
          label={label.OTHERCOUNTRIES}
          isAgreed={agree}
          getChecked={getChecked}
        >
          <TermsAndConditionsOtherContent
            selectedCountry={MODAL_COUNTRY_MAP.OTHERCOUNTRIES}
          />
        </TermsConditions>
      )}
    </>
  );
};

export default TermsAndConditionsWrapper;
